import { Component, ViewChild } from "@angular/core";
import {
  NavController,
  ViewController,
  Content,
  LoadingController
} from "ionic-angular";
import { Store } from "@ngrx/store";
import { Http, Response } from "@angular/http";
import { IdolprofilePage } from "../idolprofile/idolprofile";
import { AppState } from "../../app/app.reducer";
import { Token, TokenStatus } from "../../app/app.models";
//import { TokensFetchAction } from '../../app/app.actions';
import { TokenPage } from "../token/token";
import { WalletPage } from "../wallet/wallet";
import { AppUtilities } from "../../app/app.utilities";
import { GeneralPaginService } from "../../services/general.pagin.service";
import { NodeService } from "../../services/node.service";
import { ConfigService } from "../../services/config.service";
import { WalletService } from "../../services/wallet.service";
import * as firebase from "firebase";

@Component({
  selector: "page-marketplace",
  templateUrl: "marketplace.html"
})
export class MarketplacePage {
  public refresh;
  public tokenPage = TokenPage;
  public tokens$: Token[] = [];
  moreAssets: boolean = false;
  bitcoinValue: number;
  @ViewChild(Content)
  content: Content;
  myaddress: string;
  watacoins: string;
  error: any;
  text: string;

  constructor(
    public navCtrl: NavController,
    private nodeService: NodeService,
    private generalPaginService: GeneralPaginService,
    public utilities: AppUtilities,
    private http: Http,
    private configService: ConfigService,
    public viewCtrl: ViewController,
    private walletService: WalletService,
    public loadingCtrl: LoadingController
  ) {
    var idiom = this.configService.getIdiom();
    if (idiom == "en") this.utilities.loading("Checking Blockchain");

    if (idiom == "es") this.utilities.loading("Consultando Blockchain");
    this.myaddress = this.walletService.getAddress();
    //this.getBitcoinValue();
    this.nodeService
      .getBalanceWatacoins()
      .then(wallet => {
        var wata: any = wallet.watacoins;
        this.watacoins = this.formatNumberDeciaml(wata, 2);
        console.log("Watacoins market " + this.watacoins);
      })
      .catch(err => {
        this.error = "Saldo no disponible";
      });

    this.generalPaginService.getAssetIdsForSale().then((assetsSale: any[]) => {
      this.utilities.loadingDismiss();
      if (assetsSale) {
        this.tokens$ = [];
        for (let asset of assetsSale) {
          if (asset.status == TokenStatus.ForSale) {
            asset.next_price = this.formatNumberDeciaml(asset.next_price, 0);

            this.tokens$.push(asset);
          }
        }
        if (this.tokens$.length > 0) {
          this.moreAssets = this.generalPaginService.getMoreAssets();
        } else {
          this.moreAssets = false;
        }
      }
    });
  }

  ionViewWillEnter() {}

  ionViewDidLoad() {
    console.log("ionViewDidLoad MarketplacePage");
  }

  reciveautograph() {
    this.navCtrl.push(WalletPage);
  }

  loadMoreAssets($event) {
    if (this.content.directionY == "down" && this.moreAssets) {
      var idiom = this.configService.getIdiom();
      console.log("idom", idiom);
      if (idiom == "en") this.text = "Checking Blockchain";
      if (idiom == "es") this.text = "Consultando Blockchain";
      this.utilities.loading(this.text);

      //this.utilities.loading('Consultando Blockchain');

      setTimeout(() => {
        this.generalPaginService.getBlockAssets().then((assets: any[]) => {
          if (assets.length > 0) {
            console.log("Assets sale : " + assets);
            for (let asset of assets) {
              this.tokens$.push(asset);
            }
            this.moreAssets = this.generalPaginService.getMoreAssets();
          } else {
            this.moreAssets = this.generalPaginService.getMoreAssets();
          }
          this.utilities.loadingDismiss();
          $event.complete();
        });
      }, 1000);
    } else {
      $event.complete();
    }
  }

  doRefresh($event) {
    this.refresh = $event;
    var idiom = this.configService.getIdiom();
    if (idiom == "en") this.utilities.loading("Checking Blockchain");

    if (idiom == "es") this.utilities.loading("Consultando Blockchain");
    this.generalPaginService.getAssetIdsForSale().then((assetsSale: any[]) => {
      this.tokens$ = [];
      console.log("Assets Sale: " + assetsSale.length);
      if (assetsSale) {
        for (let asset of assetsSale) {
          if (asset.status == TokenStatus.ForSale) {
            this.tokens$.push(asset);
          }
        }
        if (this.tokens$.length > 0) {
          this.moreAssets = this.generalPaginService.getMoreAssets();
        } else {
          this.moreAssets = false;
        }
      }
      this.utilities.loadingDismiss();
      $event.complete();
    });
  }

  getBitcoinValue() {
    this.http
      .get("https://api.coinbase.com/v2/prices/spot?currency=USD")
      .subscribe((res: Response) => {
        if (res) {
          this.bitcoinValue = parseFloat(res.json().data.amount);
        }
      });
  }

  seeIdolProfile(asset) {
    var idols;
    var idol;
    this.utilities.loading("Loading Idol Profile");

    firebase
      .database()
      .ref("prod_idols/")
      .once("value")
      .then(snapshot => {
        if (snapshot.val()) {
          idols = snapshot.val();
          var keys = Object.keys(idols);
          for (let i = 0; i < keys.length; i++) {
            if (asset.issuer === idols[keys[i]].address) {
              idol = idols[keys[i]];
              this.utilities.loadingDismiss();
              this.navCtrl.push(IdolprofilePage, idols[keys[i]]);
            }
          }
        }
      });
  }

  showMy() {
    var idiom = this.configService.getIdiom();
    if (idiom == "en") this.utilities.alert("My");

    if (idiom == "es") this.utilities.alert("Mio");
  }

  formatNumberDeciaml(value: number, decimal: number): string {
    var formatValue;
    var idiom = this.configService.getIdiom();
    if (idiom == "es")
      formatValue = new Intl.NumberFormat("es-ES", {
        maximumFractionDigits: decimal
      }).format(value);

    if (idiom == "en")
      formatValue = new Intl.NumberFormat("en-US", {
        maximumFractionDigits: decimal
      }).format(value);

    return formatValue;
  }
}



// WEBPACK FOOTER //
// ./src/pages/marketplace/marketplace.ts